<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">All Article</h3>
        <button
          class="button primary small"
          @click="$router.push({ name: 'add-article' })"
        >
          <i class="fad fa-plus"></i> Add
        </button>
      </div>
    </div>
    <div class="page-content">
      <div class="box">
        <div class="box-header">
          <div class="search select">
            <select class="input" v-model="search" @change="textSearch">
              <option value="" selected="selected">All Article Type</option>

              <option v-for="(a, ind) in article" :key="ind" :value="a._id">
                {{ a.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <ArticleList />
    </div>
  </section>
</template>

<script>
import ArticleList from "@coms/article/articleList.vue";
import { REUSE } from "../graphql/manage/query";
import { apolloClient } from "@/services/apollo-client";
export default {
  components: {
    ArticleList,
  },
  data: () => ({
    article: [],
    search: "",
  }),
  methods: {
    async fetchArticle() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "BlogType",
        },
      });
      this.article = res.data.getReuses;
    },
    textSearch() {
      this.$router.push({ query: { ...this.$route.query, s: this.search } });
    },
  },
  created() {
    this.fetchArticle();
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 120px;
  width: auto;
  overflow: hidden;
  img {
    height: 120px;
  }
}
.box {
  margin-bottom: 0;
}
.box-header {
  margin-bottom: 0 !important;
}
</style>
